//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';
import { isPlaceSearchError } from 'components/PlaceAutocomplete/PlaceSearchUnavailableNotice';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  includeExpired: false,
  excludeOutcome: false,
  scope: 'mine',
  competenceAreas: [],
  place: null,
  radiusKm: 25,
  ownerTypes: [],
  buyerID: null,
  assignedUserID: null,
  starred: false,
  sortBy: 'dateCreated',
  queryKey: ['jobAds'],
  queryOptions: {},
};

const getAll = async (queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams }, {
    arrayFormat: 'repeat',
    skipNulls: true,
  });

  const { data } = await axios.get(`/api/job_ads?${queryString}`);

  return data;
};

export const searchJobAds = async (search, scope = 'mine') => {
  const { data } = await getAll({
    search,
    scope,
    limit: 15,
    includeinactive: true,
    includexpired: true,
  });

  return { data: data ?? [] };
};

export const useGetAll = (queryParams = {}) => {
  const { queryKey, queryOptions, page, limit, scope, search, includeInactive, includeExpired, sortBy, competenceAreas, place, radiusKm, ownerTypes, buyerID, assignedUserID, starred, excludeOutcome } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    includexpired: includeExpired,
    scope,
    competence_area_ids: competenceAreas,
    place_id: place?.place_id ?? null,
    radius_km: place ? radiusKm : null,
    owner_types: ownerTypes,
    buyer_id: buyerID,
    assigned_user_id: assignedUserID,
    starred: starred || null,
    sortby: sortBy,
    offset: page * limit,
    excludeOutcome: excludeOutcome,
  };

  return useQuery([...queryKey, scope, place?.place_id, radiusKm, ...competenceAreas, ...ownerTypes, buyerID, assignedUserID, starred], () => getAll(queryStringParams), {
    select: ({ data: jobAds, total, search_area }) => ({ jobAds: jobAds ?? [], total, searchArea: search_area ?? null }),
    initialData: {
      data: [],
      total: 0,
    },
    retry: (failureCount, error) => !isPlaceSearchError(error) && failureCount < 3,
    ...queryOptions,
  });
};
